/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
const types = {
  dependenciesConfig: Symbol.for("Types.dependenciesConfig"),
};

export { types as Types };
